<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择方法"
      width="80%"
      top="5vh">
    <el-table :data="dealMethod">
      <el-table-column prop="repairMethodName" align="center" label="方法"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

  export default {
    name:"RepairMethodSelect",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        dealMethod:[
          {id: 10,repairMethodName: "内修"},
          {id: 20,repairMethodName: "外修"},
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
